import { createReducer } from 'redux-create-reducer'
import * as SettingsActions from '../actions/settings-actions';

const initialState = {
    type: ['index', 'vector'],
    rank: 0.1
}

const settingsReducer = createReducer(initialState, {
    [SettingsActions.SET_SETTINGS]: (state, { payload: { settings } }) => ({
        ...state, ...settings
    })
});

export default settingsReducer
